import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import {
    IAdminConsoleApi,
    ILoggingAreas,
    IProvisionAdminOptions,
    ITemplateStudyLookUp,
    IVirtualMachineLookup
} from '@vivli/features/admin-console/infrastructure/interface';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';

export const useAdminConsoleApi = (): IAdminConsoleApi => {
    const { handleGet, handlePost, handlePut } = useAuthRestApi();
    const getTemplateStudy = (nctOrSponsorID: string): Observable<ITemplateStudyLookUp> => {
        const encodedNctOrSponsorId = encodeURIComponent(nctOrSponsorID);
        return handleGet<ITemplateStudyLookUp>(`/studies/adminStudy?id=${encodedNctOrSponsorId}`);
    };

    const getRequestData = (dataRequestDoi: string): Observable<IDataRequest> => {
        return handleGet<any>(`/datarequests/${dataRequestDoi}/ops`);
    };

    const performAction = (operation: string, id: string, data: string, comment: string): Observable<any> => {
        let url = `/admin/${operation}/${id}`;
        if (data) {
            url = url + `/${data}`;
        }
        return handlePut<any>(url, `${comment}`);
    };

    const getVMData = (VMDoi: string): Observable<IVirtualMachineLookup> => {
        return handleGet<any>(`/admin/VM/${VMDoi}`);
    };

    const provisionVm = (id: string, options: IProvisionAdminOptions): Observable<any> => {
        return handlePost<any>(`/admin/${id}/requestToProvision`, options);
    };

    const downloadAudit = (startDate: Date, endDate: Date, type: string, id: string, comment: string): Observable<string> => {
        const url1 = `/admin/audit?startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}`;
        const urlType = type ? `&type=${type}` : '';
        const urlId = id ? `&id=${id}` : '';
        const urlCom = comment ? `&commentPart=${comment}` : '';

        const url2 = `${urlType}${urlId}${urlCom}`;
        return handleGet<any>(`${url1}${url2}`);
    };

    const getAuditPresence = (type: string, id: string): Observable<boolean> => {
        return handleGet<boolean>(`/admin/auditPresence?type=${type}&id=${id}`);
    };

    const getLoggingDetails = (): Observable<ILoggingAreas[]> => {
        return handleGet<ILoggingAreas[]>('/admin/LoggingAreas');
    };

    const updateLoggingDetails = (updatedLoggingAreaDetails: ILoggingAreas[]): Observable<void> => {
        return handlePost<void>('/admin/LoggingAreas', updatedLoggingAreaDetails);
    };

    return {
        getTemplateStudy,
        getRequestData,
        performAction,
        getVMData,
        provisionVm,
        downloadAudit,
        getAuditPresence,
        getLoggingDetails,
        updateLoggingDetails
    };
};
